import React, { useState } from 'react';
import {
  handleRemoveFlightBundle,
  setWholeCart,
} from '../../ShoppingCartSliceV2';
import { Product } from '../../interfaces';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import { Link } from 'react-router-dom';
import { flightLink } from '@skygroup/shared/utils/B2CLinks';
import { FlightType } from '../../../../interfaces/flightInterface';
import moment from 'moment';
import { IoClose } from 'react-icons/io5';
import FlightCard2 from '../../../SearchDatePicker/widgets/SearchResults/FlightCard2';
import ProductPreviewComponent from '../../widgets/ProductPreviewComponent';
import { Button } from 'antd';
import BaggageManagement from '@skygroup/shared/components/baggageManagment/baggageManagment';
import useHandleManageBaggage from '../../hooks/useHandleManageBaggage';
import { MainProductType } from '../../interfaces';
import SupplierCancellationPolicyNotice from '../../widgets/SupplierCancellationPolicyNotice';
import { FaBaby, FaChild } from 'react-icons/fa';
import { IoIosMan } from 'react-icons/io';
// import './shoppingCartFlightPackage.less';

interface Props {
  product: Product;
  isCheckoutPage: boolean;
  hideCloseIcon?: boolean;
  showProductPrice?: boolean;
  isTopLevel?: boolean;
  mainProductType?: MainProductType;
}

const ShoppingCartOneWayFlight = ({
  product,
  isCheckoutPage,
  hideCloseIcon,
  showProductPrice = true,
  isTopLevel = false,
  mainProductType,
}: Props) => {
  const { shoppingCartTranslations: t, manageBaggage } = useSelector(
    (data: RootState) => data.config.translations
  );

  const { config, direction } = useSelector((data: RootState) => data.config);

  const { ShoppingCartV2 } = useSelector(
    (state: RootState) => state.shoppingCartV2
  );

  const [isManageBaggageOpen, setIsManageBaggageOpen] = useState(false);
  const {
    handleAddBaggage,
    notifyBaggageSaved,
    flightBackBaggage,
    flightFromBaggage,
    isRoundTrip,
    isShowManageBaggageButton,
    isSavedProduct,
    saveSavedOrderBaggage,
    isSavingSaved,
  } = useHandleManageBaggage({ product });

  const generateFlightLink = (data: any) => {
    const startDate = moment(data.flightsInfo.flightFrom.departure_date * 1000);

    const departureDate = startDate.format(config?.siteConfig?.dateFormat);
    const from = encodeURIComponent(departureDate);

    const adultCount = data.pax.adult;
    const childCount = data.pax.child;
    const infantCount = data.pax.infant;

    const departureAirport = data.flightsInfo.flightFrom[0].from.code;
    let link = `?from=${from}&adult=${adultCount}&oneWay=1&departure=${departureAirport}&child=${childCount}&infant=${infantCount}`;

    if (data.flightsInfo.flightBack) {
      const endDate = moment(
        data.flightsInfo.flightBack[0].departure_date * 1000
      );
      const returnDate = endDate.format(config?.siteConfig?.dateFormat);
      const to = encodeURIComponent(returnDate);
      const destinationAirport = data.flightsInfo.flightBack[0].to.id;
      link += `&to=${to}&oneWay=0&destination=${destinationAirport}`;
    }
    return link;
  };

  const searchParams = generateFlightLink(product.product_data);

  const dispatch = useDispatch();

  const handleRemoveFlight = () => {
    dispatch(handleRemoveFlightBundle(product));
  };

  const flightFrom = product.product_data.flightsInfo.flightFrom;

  const adultCount = product.product_data?.pax?.adult;
  const childCount = product.product_data?.pax?.child;
  const infantCount = product.product_data?.pax?.infant;

  const combinedSubProducts =
    product?.subProducts
      ?.map((subProduct) => subProduct.identifier)
      .join(',') ?? '';

  // Bags are shown as separate line items; display only the flight-only price.
  // When bundle total_price > 0 it holds the converted flight+bag total, so
  // subtract bags. When it's 0 the cart falls through to leg sub-products, so
  // sum the legs directly (each leg's total_price already includes its bags).
  const legBaggageTotal = (legs: typeof product.subProducts) =>
    legs?.reduce((sum, leg) => {
      return (
        sum +
        (leg.subProducts?.reduce((bagSum, bag) => {
          if (
            bag.type === MainProductType.Suitcase ||
            bag.type === MainProductType.Trolly
          ) {
            return bagSum + (bag.total_price ?? 0);
          }
          return bagSum;
        }, 0) ?? 0)
      );
    }, 0) ?? 0;

  const flightDisplayPrice =
    (product.total_price ?? 0) > 0
      ? (product.total_price ?? 0) - legBaggageTotal(product.subProducts)
      : (product.subProducts?.reduce(
          (sum, leg) => sum + (leg.total_price ?? 0),
          0
        ) ?? 0) - legBaggageTotal(product.subProducts);
  return (
    <div>
      <div className="shopping-cart-flights shopping-cart-flights-package">
        <b className="product-title">
          {t?.flights}{' '}
          {isShowManageBaggageButton && (
            <Button
              id="obs-cart-manage-baggage-btn"
              onClick={() => setIsManageBaggageOpen(true)}
              className="btn-style-4"
            >
              {t.manageBaggage}
            </Button>
          )}
        </b>
        {isShowManageBaggageButton && (
          <div className="cart-baggage-hint">{isSavedProduct ? t.savedBaggageHint : t.manageBaggageHint}</div>
        )}

        {isManageBaggageOpen && (
          <BaggageManagement
            guests={ShoppingCartV2.guests}
            onChange={handleAddBaggage}
            flightBackBaggage={flightBackBaggage}
            flightFromBaggage={flightFromBaggage}
            mainProduct={product}
            shoppingCart={ShoppingCartV2}
            onClose={(cart: any) => {
              dispatch(setWholeCart(cart));
            }}
            isManageBaggageOpen={isManageBaggageOpen}
            setIsManageBaggageOpen={setIsManageBaggageOpen}
            onSave={(prevCart) =>
              isSavedProduct
                ? saveSavedOrderBaggage(prevCart, () => setIsManageBaggageOpen(false))
                : (notifyBaggageSaved({}), setIsManageBaggageOpen(false))
            }
            isSaving={isSavingSaved}
            isRoundTrip={isRoundTrip}
            t={manageBaggage}
            direction={direction}
          />
        )}
        {/* <Link
          to={flightLink(FlightType.OneWay, combinedSubProducts, searchParams)}
          className="flight-link"
        >
          {flightFrom[0].from.name} → {flightFrom[flightFrom.length -1].to.name}
        </Link> */}

        <ProductPreviewComponent
          productPath={flightLink(
            FlightType.OneWay,
            combinedSubProducts,
            generateFlightLink(product.product_data)
          )}
          label={
            <>
              {flightFrom[0].from.name} →{' '}
              {flightFrom[flightFrom.length - 1].to.name}
            </>
          }
          labelClassName={'flight-link'}
          showActionButtons={mainProductType !== MainProductType.DynamicPackage}
        />

        <SupplierCancellationPolicyNotice product={product} />

        {isTopLevel && (
          <div
            className="last-row"
            style={{
              justifyContent: showProductPrice ? 'space-between' : 'flex-end',
            }}
          >
            {showProductPrice && (
              <div className="product-guests">
                <div className="adult">
                  <IoIosMan size={20} />
                  <span>{`X${adultCount}`}</span>
                </div>
                {childCount > 0 && (
                  <div className="child">
                    <FaChild size={16} />
                    <span>{`X${childCount}`}</span>
                  </div>
                )}
                {infantCount > 0 && (
                  <div className="child">
                    <FaBaby size={16} />
                    <span>{`X${infantCount}`}</span>
                  </div>
                )}
              </div>
            )}
            <div className="price-box">
              {showProductPrice && (
                <span>{`${Math.ceil(flightDisplayPrice)} ${
                  product?.base_currency_sign ??
                  product?.product_data?.flightsInfo?.price?.currency_sign
                }`}</span>
              )}

              {!hideCloseIcon && (
                <IoClose
                  size={15}
                  onClick={handleRemoveFlight}
                  className="delete-product ease"
                />
              )}
            </div>
          </div>
        )}

        <div className="flights-package-wrapper">
          <div style={{ flexDirection: 'column', display: 'flex', gap: 5 }}>
            {product.subProducts?.map((subProduct, i) => {
              return (
                <FlightCard2
                  key={i}
                  flightData={subProduct.product_data}
                  isShowFlightButton={false}
                  handlePurchase={() => {}}
                  flightFromSubProducts={subProduct.subProducts}
                  isMinimized
                  showProductPrice={showProductPrice}
                  isCartView
                />
              );
            })}
          </div>

          {!isCheckoutPage && !isTopLevel && (
            <IoClose
              size={15}
              onClick={handleRemoveFlight}
              className="delete-product ease"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ShoppingCartOneWayFlight;
